<template>
  <div>
    <t-form ref="form" @submit.prevent>
      <ServiceRadioFormPart @result="onResult" @change="onChange" />
    </t-form>

    <FormErrorMessages :error-messages="errorMessages" />
  </div>
</template>

<script>
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep'
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import ServiceRadioFormPart from 'chimera/windowFrames/components/form/parts/service/ServiceRadioFormPart.be'
import { useExperiments } from 'chimera/all/composables/useExperiments'
import { SKALE_0018_KOZIJNEN_QUESTIONS_IN_FLOW } from 'chimera/all/constants/experiments'
import NextStep from '~/pages/offertes-aanvragen/uw-gegevens'
import ExecutionPeriodStep from '~/pages/offertes-aanvragen/wanneer-ramen-plaatsen'

export default {
  name: 'ServiceTypeFormStep',

  components: {
    ServiceRadioFormPart,
    FormErrorMessages,
  },

  extends: AbstractFormStep,

  /**
   * Pass through the submit event given from FormModal
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit')
  },

  methods: {
    /**
     * Expose late (PD-10940): only completers become participants.
     */
    async transition() {
      const { getExperiment, isVariant } = useExperiments(this.$store)
      const experiment = await getExperiment(
        SKALE_0018_KOZIJNEN_QUESTIONS_IN_FLOW,
      )
      this.routeTo(isVariant(experiment, 1) ? ExecutionPeriodStep : NextStep)
    },
  },
}
</script>
